import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormDescription, FormField, FormItem } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';

const InputCheckbox = ({
  name,
  className,
  minLength = 3,
  maxLength = 100,
  label,
  description = '',
  isRequired = false,
  onClick = () => {},
  onCheckBoxClick = () => {},
  disabled = false
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });

  const validationRules = {
    minLength: {
      value: minLength,
      message: t('minLength'),
    },
    maxLength: {
      value: maxLength,
      message: t('maxLength'),
    },
  };

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={` ${className}`}>
      <FormField
        name={name}
        key={name}
        control={control}
        defaultValue={false}
        rules={validationRules}
        render={({ field }) => (
          <FormItem className='tw-flex tw-flex-col'>
            <FormControl>
              <div
                className='tw-items-top tw-gap-1.5 tw-flex space-x-2'
                onClick={() => onClick(!field.value)}
              >
                <Checkbox disabled={disabled} id={name} onClick={() => onCheckBoxClick()} checked={field.value} onCheckedChange={field.onChange} />
                <div className='tw-grid tw-gap-1.5'>
                  <label
                    htmlFor={name}
                    className='tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70'
                  >
                    {label}
                  </label>
                  <FormDescription>{description}</FormDescription>
                </div>
              </div>
            </FormControl>
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputCheckbox;
